<div class="mobile-card-list" *ngIf="config">
  <div class="mobile-card-list__item" *ngFor="let item of data">
    <div class="mobile-card-list__inner">
      <div class="mobile-card-list__header">
        <div class="mobile-card-list__header-content">
          <span class="mobile-card-list__header-value">
            <span *ngIf="config.headerLabel" class="mobile-card-list__header-hash">{{ config.headerLabel }}</span>
            {{ item[config.headerKey] }}
          </span>
        </div>
        <div class="mobile-card-list__header-content-right-container">
          <div class="mobile-card-list__header-value mobile-card-list__header-value-right" *ngIf="config.headerLabelRight">
            <span class="mobile-card-list__header-label-right">{{ config.headerLabelRight }}</span>
            <span *ngIf="config.headerKeyRight" class="mobile-card-list__header-key-right">
              {{ config.subHeaderKeyRight ? item[config.headerKeyRight]?.[config.subHeaderKeyRight] 
            : item[config.headerKeyRight] ?? '-' }}</span>          
          </div>          
        </div>
      </div>      
      <div class="mobile-card-list__content">
        <div 
          class="mobile-card-list__row" 
          *ngFor="let field of config.fields"
          [class.mobile-card-list__row--highlight]="field.highlight"
          [class.mobile-card-list__row--bold]="field.bold"
          [class.mobile-card-list__row--gray-text]="field.grayText"
          >
          <span 
            class="mobile-card-list__label"
            [class.mobile-card-list__label--amount]="field.isAmount">
            {{ field.label }}
          </span>
          <span 
            class="mobile-card-list__value"
            [class.mobile-card-list__value--amount]="field.isAmount">
            {{ field.isAmount ? (item[field.key] | amount : true :  (field.currencyCode && item[field.currencyCode] != undefined ? getCurrencySymbol(item[field.currencyCode]): "") : ( field.currencyCode && item[field.currencyCode] != undefined ? item[field.currencyCode] : ""))
            : field.isDate ? (item[field.key] | customDate ) : item[field.key] }}
          </span>
        </div>
      </div>
    </div>
    <div class="mobile-card-list__action-container" *ngIf="config.showActionButton">
      <button 
        class="mobile-card-list__action-btn" 
        (click)="toggleMenu(item)">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" [attr.fill]="menuColor" viewBox="0 0 16 16">
          <circle cx="8" cy="3" r="1.5"/>
          <circle cx="8" cy="8" r="1.5"/>
          <circle cx="8" cy="13" r="1.5"/>
        </svg>
      </button>
      <div class="mobile-card-list__dropdown" *ngIf="showMenuForItem === item">
        <button 
          class="mobile-card-list__dropdown-item"
          *ngFor="let action of config?.actions || ['search']"
          (click)="onCardAction(item, action)">
          {{ 'IP.ACTIONS_TOOLTIP.' + action.toUpperCase() | translate }}
        </button>
      </div>
    </div>
  </div>
  
  <div class="no-data" *ngIf="showNoData">
    <app-ip-empty-data />
  </div>
</div>
